import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-smart-component-spinner',
    templateUrl: './smart-component-spinner.component.html',
    styleUrls: ['./smart-component-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class SmartComponentSpinnerComponent implements OnInit {

  @Input() public greyTheme: boolean = false;

  ngOnInit() {}

}
